var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3429 17.0474C21.358 15.8852 21.6674 14.7458 22.2422 13.735C22.8171 12.7241 23.639 11.8749 24.6312 11.2662C24.0008 10.368 23.1693 9.62866 22.2026 9.10723C21.2358 8.58565 20.1605 8.29632 19.0621 8.26207C16.719 8.0166 14.4474 9.6611 13.2534 9.6611C12.0364 9.6611 10.198 8.28644 8.21829 8.32695C6.93778 8.36831 5.68992 8.73979 4.5961 9.40547C3.50229 10.0712 2.60006 11.0081 1.97703 12.1251C-0.72157 16.7873 1.29135 23.6392 3.87638 27.4077C5.16973 29.253 6.68131 31.3144 8.65908 31.2413C10.5946 31.1612 11.3174 30.0098 13.6536 30.0098C15.9682 30.0098 16.6463 31.2413 18.6643 31.1948C20.7411 31.1612 22.0497 29.3413 23.2975 27.4785C24.2268 26.1635 24.942 24.7103 25.4164 23.1726C24.2098 22.6633 23.1801 21.811 22.4557 20.7218C21.7314 19.6326 21.3443 18.3547 21.3429 17.0474Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5315 5.78354C18.6638 4.42711 19.2217 2.68362 19.0866 0.92337C17.3565 1.10468 15.7586 1.92973 14.6109 3.23413C14.0498 3.87135 13.62 4.61271 13.3461 5.41582C13.0724 6.21879 12.9598 7.06784 13.015 7.91439C13.8803 7.9233 14.7363 7.73603 15.5187 7.36706C16.3011 6.99795 16.9892 6.45646 17.5315 5.78354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.9595594e007208f46f74fff2f6fea673.svg";
export { ForwardRef as ReactComponent };